<template>
  <div class="developer">
    <TopNav :curTabProps="'1'"/>
    <el-row type="flex" justify="start" class="choose-date">
      <!-- <ChooseDate :showIntervalDate="true" :dateValue.sync="dateValue"/> -->
    <ChooseDateAndCustomer :showCustomer="false" @paramsInfo="receiveParamsInfo"/>
    </el-row>
    <el-row class="summary-row">
      <el-col :span="12">
        <div class="chart-summary">
          <el-row type="flex" justify="space-between">
            <div>活跃企业开发者分析</div>
            <div>活跃客户<i>{{company.todayActiveCompanyCustomerCnt}}</i>家</div>
            <div>服务时长<i>{{company.todayCompanyOrderDuration}}</i>分钟</div>
          </el-row>
          <el-row style="height: 250px;" type="flex" justify="space-between">
            <el-col style="width: 250px;height: 250px">
              <PieChart :pieDataProps="pieOne" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'客户活跃数量'" />
            </el-col>
            <el-col style="width: 250px;height: 250px">
              <PieChart :pieDataProps="pieTwo" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'客户服务类型'"/>
            </el-col>
            <el-col style="width: 250px;height: 250px">
              <PieChart :pieDataProps="pieThree" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'客户服务行业类型'"/>
            </el-col>
          </el-row>
          <!-- 折线图 -->
          <div>
            <div class="line-tab">
              <span @click="companyTabClick('活跃企业')" :class="companyTab==='活跃企业'?'active':''">活跃企业</span>
              <span @click="companyTabClick('新增企业')" :class="companyTab==='新增企业'?'active':''">新增企业</span>
              <span @click="companyTabClick('服务时长')" :class="companyTab==='服务时长'?'active':''">服务时长</span>
              <span @click="companyTabClick('活跃平台')" :class="companyTab==='活跃平台'?'active':''">活跃平台</span>
            </div>
            <div style="width: 100%;height:200px;margin-bottom: 60px;">
              <div v-if="JSON.stringify(companyLineChart[0])==='[]'&&JSON.stringify(companyLineChart[1])==='[]'">
                <el-empty style="width: 100%; height: 200px; margin-bottom: 60px;" description="暂无数据"></el-empty>
              </div>
              <LineChart v-else 
                :lineDataProps="companyLineChart" 
                :LineNameProps="companyTab" 
                :axisNameProps="companyTab==='服务时长'?{xName: lineChartXName,yName: '/分钟'}:{xName: lineChartXName,yName: '/数量'}"/>
            </div>
          </div>
          <!-- 下载图表 -->
          <div>
            <TableForDownload
              :tableColumnsProps="companyTabColumns"
              :tableDataProps="companyTableDataProps"
              :themeColor="{color:'#F28639',colorOpa: 'rgba(242, 134, 57, 0.05)'}" />
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="chart-summary">
          <el-row type="flex" justify="space-between">
            <div style="background:#A89700!important;">活跃个人开发者分析</div>
            <div>活跃开发者<i>{{personal.todayActivePersonalCustomerCnt}}</i>家</div>
            <div>服务时长<i>{{personal.todayPersonalOrderDuration}}</i>分钟</div>
          </el-row>
          <el-row style="height: 250px;" type="flex" justify="space-around">
            <el-col style="width: 250px;height: 250px">
              <PieChart :pieDataProps="pieFour" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'开发者活跃数量'" />
            </el-col>
            <el-col style="width: 250px;height: 250px">
              <PieChart :pieDataProps="pieFive" :pieObj="{key: 'name',value:'value'}" :pieTitleProps="'客户服务行业类型'"/>
            </el-col>
          </el-row>
          <!-- 折线图 -->
          <div>
            <div class="line-tab">
              <span @click="personalTabClick('活跃开发者')" :class="personalTab==='活跃开发者'?'personal-active':''">活跃开发者</span>
              <span @click="personalTabClick('新增开发者')" :class="personalTab==='新增开发者'?'personal-active':''">新增开发者</span>
              <span @click="personalTabClick('服务时长')" :class="personalTab==='服务时长'?'personal-active':''">服务时长</span>
            </div>
            <div style="width: 100%;height:200px;margin-bottom: 60px;">
              <div v-if="JSON.stringify(personalLineChart[0])==='[]'&&JSON.stringify(personalLineChart[1])==='[]'">
                <el-empty style="width: 100%; height: 200px; margin-bottom: 60px;" description="暂无数据"></el-empty>
              </div>
              <LineChart v-else 
                :lineDataProps="personalLineChart" 
                :LineNameProps="personalTab"  
                :axisNameProps="personalTab==='服务时长'?{xName: lineChartXName,yName: '/分钟'}:{xName: lineChartXName,yName: '/数量'}"/>
            </div>
          </div>
          <!-- 下载图表 -->
          <div>
            <TableForDownload
              :tableColumnsProps="personalTabColumns"
              :tableDataProps="personalTableDataProps"
              :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}" />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 服务行业领域分析 -->
    <div class="chart-summary" style="padding-top: 50px;margin-top:50px;border-top:1px solid #5E5E5E;">
    <el-row type="flex" justify="start">
      <div style="background: #5B9BD5!important;">服务行业领域分析</div>
      <div style="margin: 0 100px;">服务行业<i>{{busiScope.todayActiveBusiScopeCnt}}<i style="font-size: 30px;">+</i></i>个</div>
      <div>服务时长<i>{{busiScope.busiScopeDurationTotal}}</i>分钟</div>
    </el-row>
    </div>
    <el-row class="summary-row">
      <el-col :span="12">
        <div>
          <TableForDownload
            :tableColumnsProps="busiScopeTabColumns"
            :tableDataProps="busiScopeTableProps"
            :themeColor="{color:'#5B9BD5',colorOpa: 'rgba(91, 155, 213, 0.05)'}" />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="serve-tab">
          <span @click="busiScopeTabClick('服务时长')" :class="busiScopeTab==='服务时长'?'active':''">服务时长</span>
          <span @click="busiScopeTabClick('活跃平台')" :class="busiScopeTab==='活跃平台'?'active':''">活跃平台</span>
          <span @click="busiScopeTabClick('活跃用户')" :class="busiScopeTab==='活跃用户'?'active':''">活跃用户</span>
          <span @click="busiScopeTabClick('新增开发者')" :class="busiScopeTab==='新增开发者'?'active':''">新增开发者</span>
        </div>
        <div style="width: 100%;height:250px;">
          <BarChart :barDataProps="orderDurationTopByBusiScopeChart" />
        </div>
        <!-- 筛选条件下拉 -->
        <el-row style="margin-top: 60px;padding-left: 20px;">
          <el-select v-model="busiScopeLineSelectvalue" placeholder="请选择" size="mini" style="margin-right: 50px;" @change="selectBusiScopeChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-select v-model="busiScopeLineSelectvalue" placeholder="请选择" size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select> -->
        </el-row>
        <div style="width: 100%;height:200px;">
          <div v-if="JSON.stringify(durationByBusiScopeLine[0])==='[]'&&JSON.stringify(durationByBusiScopeLine[1])==='[]'">
                <el-empty style="width: 100%; height: 200px; margin-bottom: 60px;" description="暂无数据"></el-empty>
              </div>
          <LineChart v-else 
            :lineDataProps="durationByBusiScopeLine" 
            :LineNameProps="busiScopeLineSelectvalue" 
            :axisNameProps="{xName: lineChartXName,yName: '/分钟'}"/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import TopNav from '../Components/topNav.vue'
// import ChooseDate from '../Components/chooseData.vue'
import PieChart from '@/components/chartComponents/pie.vue'
import LineChart from '@/components/chartComponents/line.vue'
import TableForDownload from '../Components/tabeleFordownload.vue'
import BarChart from '@/components/chartComponents/bar.vue'
import ChooseDateAndCustomer from '../Components/chooseDataAndCustomer.vue'

export default {
  components: {
    TopNav,
    // ChooseDate,
    PieChart,
    LineChart,
    TableForDownload,
    BarChart,
    ChooseDateAndCustomer
  },
  data() {
    return {
      dateValue: 'today',
      lineChartXName: '24小时',
      company: {
        todayActiveCompanyCustomerCnt: 0, // 活跃客户
        todayCompanyOrderDuration: 0, //服务时长
      },
      personal: {
        todayActivePersonalCustomerCnt: 0, // 活跃开发者
        todayPersonalOrderDuration: 0, //服务时长
      },
      busiScope: {
        todayActiveBusiScopeCnt: 0, // 服务行业数todayOrderDurationBusiScope
        busiScopeDurationTotal: 0, // 服务时长
      },
      pieOne: [],
      pieTwo: [],
      pieThree: [],
      companyLineChart: [],
      // 活跃企业折线图
      companyActivityLine: [],
      increaseCompanyCustomerLine: [[],[]], // 新增企业数
      companyOrderDurationLine: [[],[]], //服务时长
      companySnLine: [[],[]], // 活跃平台数
      companyTabColumns: [
        {key: '',label: '序号'},
        {key: 'customerName',label: '客户名称'},
        {key: 'duration',label: '服务时长（分钟）'},
        {key: 'snCnt',label: '注册平台数'},
        {key: 'serviceTypeSelf',label: '服务类型'},
        {key: 'busiScope',label: '所属行业'},
      ],
      companyTableDataProps: [], //企业开发者排行
      personalTabColumns: [
        {key: '',label: '序号'},
        {key: 'customerName',label: '开发者名称'},
        {key: 'duration',label: '服务时长（分钟）'},
        {key: 'busiScope',label: '所属行业'},
      ],
      personalTableDataProps: [], //个人开发者排行
      busiScopeTabColumns: [
        {key: '',label: '序号'},
        {key: 'busiScope',label: '一级行业'},
        // {key: '',label: '二级行业'},
        {key: 'duration',label: '服务时长（分钟）'},
        {key: 'snCnt',label: '注册平台数'},
        {key: 'companyCnt',label: '企业数量'},
        {key: 'personalCnt',label: '开发者数量'},

      ],
      busiScopeTableProps: [], //服务行业排行
      pieFour: [], // 开发者活跃数量
      pieFive: [], // 客户服务类型
      personalLineChart: [],
      activePersonalCustomerLine: [[],[]], //活跃开发者数
      increasePersonalCustomerLine: [[],[]], // 新增开发者数
      personalOrderDurationLine: [[],[]], // 服务时长
      orderDurationTopByBusiScopeChart: [],
      orderDurationTopByBusiScopeBar: [[],[]], //服务行业领域-服务时长
      activeSnTopByBusiScopeBar:  [[],[]], //服务行业领域-活跃平台数
      activeCustomerTopByBusiScopeBar: [[],[]], //服务行业领域-活跃用户数
      increaseCustomerTopByBusiScopeBar: [[],[]], //服务行业领域-新增开发者
      busiScopeTab: '服务时长',
      companyTab: '活跃企业',
      personalTab: '活跃开发者',
      // 服务行业折线图下拉勾选
      busiScopeLineSelectvalue: '',
      options: [],
      orderDurationOptions: [], //服务行业领域-服务时长
      activeSnOptions: [], //服务行业领域-活跃平台数
      activeCustomerOptions: [], //服务行业领域-活跃用户数
      increaseCustomerOptions: [], //服务行业领域-新增开发者
      durationByBusiScopeLineArray: [],
      orderDurationLineArray: [], //服务行业领域-服务时长
      activeSnLineArray: [], //服务行业领域-活跃平台数
      activeCustomerLineArray: [], //服务行业领域-活跃用户数
      increaseCustomerLineArray: [], //服务行业领域-新增开发者
      durationByBusiScopeLine: [[],[]],
      // *****************************************开发者分析-new
      summaryParmasInfo: {// 查询开发者分析需要的查询参数
        statUnit: 'currentDay',
      },
    }
  },
  mounted() {},
  watch: {
    'summaryParmasInfo': {
      handler(val) {
        this.getCompanyAndDeveloperSummary();
        if(val.statUnit==='day' || val.statUnit==='currentDay') this.lineChartXName = '日';
        if(val.statUnit==='month') this.lineChartXName = '月';
        if(val.statUnit==='year') this.lineChartXName = '年';
        // if(val==='today') {
        //   this.getTodayDatasByCustomer();
        //   this.getTodayTopDatasByCustomer();
        // }else if(val==='week'||val==='month'||val==='year') {
        //   if(val==='week') this.lineChartXName = '7天';
        //   if(val==='month') this.lineChartXName = '日期';
        //   if(val==='year') this.lineChartXName = '12月';
        //   this.getHistoryDatasByCustomer();
        //   this.getHistoryTopDatasByCustomer();
        // }else if(val.length===2) {// 月份区间
        //   this.lineChartXName = '日期';
        //   this.getDatasByCustomer();
        // }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    receiveParamsInfo(val) {
      console.log(val)
      this.summaryParmasInfo = val;
    },
    // 开发者分析 - new
    getCompanyAndDeveloperSummary() {
      let params = {
        ...this.summaryParmasInfo
      }
      this.resetData();
      this.getRequest("/dev/system/dvw/taskOrder/getCompanyAndDeveloperSummary",params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          // ********************活跃企业开发者分析*******************************
          this.company.todayActiveCompanyCustomerCnt = data.activeCompanyCnt||0;
          this.company.todayCompanyOrderDuration = data.companyOrderDuration||0;
          // 客户活跃数量
          this.pieOne = [
            { value: data.activeCompanyCnt, name: '活跃客户数' },
            { value: data.increaseCompanyCnt, name: '新增客户数' } 
          ]
          // 客户类型
          data.companyServiceCnt.map(item => {
            if(item.type==='hawk') {
              this.pieTwo.push({value:item.cnt,name: '交付型'});
            } else {
              this.pieTwo.push({value:item.cnt,name: '运营型'});
            }
          })
          // 客户行业类型
          if(data.companyBusiScopeCnt.length>0) this.pieThree = data.companyBusiScopeCnt.map(item => {
            return {
              value: item.cnt,
              name: item.type
            }
          })
          // 活跃企业数-折线图
          data.activeCompanyCntList.map(item => {
            this.companyActivityLine[0].push(item.type);
            this.companyActivityLine[1].push(item.cnt);
          })
          this.companyLineChart = this.companyActivityLine;
          // 新增企业数
          data.increaseCompanyCntList.map(item => {
            this.increaseCompanyCustomerLine[0].push(item.type);
            this.increaseCompanyCustomerLine[1].push(item.cnt);
          })
          // 服务时长
          data.companyOrderDurationList.map(item => {
            this.companyOrderDurationLine[0].push(item.type);
            this.companyOrderDurationLine[1].push(item.duration);
          })
          // 活跃平台数
          data.activeCompanySnCntList.map(item => {
            this.companySnLine[0].push(item.type);
            this.companySnLine[1].push(item.cnt);
          })

          // ********************活跃个人开发者分析*******************************
          this.personal.todayPersonalOrderDuration = data.developerOrderDuration||0;
          this.personal.todayActivePersonalCustomerCnt = data.activeDeveloperCnt || 0;
           // 开发者活跃数量
          this.pieFour = [
            { value: data.activeDeveloperCnt, name: '活跃客户数' },
            { value: data.increaseDeveloperCnt, name: '新增客户数' }
          ]
          // 客户服务类型
          this.pieFive = data.developerBusiScopeCnt.map(item => {
            return {
              value: item.cnt,
              name: item.type
            }
          })
          // 活跃开发者数
          data.activeDeveloperCntList.map(item => {
            this.activePersonalCustomerLine[0].push(item.type);
            this.activePersonalCustomerLine[1].push(item.cnt);
          })
          this.personalLineChart = this.activePersonalCustomerLine;
          // 新增开发者数
          data.increaseDeveloperCntList.map(item => {
            this.increasePersonalCustomerLine[0].push(item.type);
            this.increasePersonalCustomerLine[1].push(item.cnt);
          })
          // 服务时长
          data.developerOrderDurationList.map(item => {
            this.personalOrderDurationLine[0].push(item.type);
            this.personalOrderDurationLine[1].push(item.duration);
          })

          // ********************服务行业领域分析*******************************
          this.busiScope.todayActiveBusiScopeCnt = data.activeBusiScopeCnt || 0;
          // 服务行业领域总时长
          this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
          
          // 服务时长
          data.orderDurationTopByBusiScope.map(item => {
            this.orderDurationTopByBusiScopeBar[0].push(item.type);
            this.orderDurationTopByBusiScopeBar[1].push(item.duration);
          })
          this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
          // 活跃平台数
          data.activeSnTopByBusiScope.map(item => {
            this.activeSnTopByBusiScopeBar[0].push(item.type);
            this.activeSnTopByBusiScopeBar[1].push(item.cnt);
          })
          //活跃用户数
          data.activeCustomerByBusiScope.map(item => {
            this.activeCustomerTopByBusiScopeBar[0].push(item.type);
            this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
          })
          // 新增开发者
           data.increaseCustomerTopByBusiScope.map(item => {
            this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
            this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
          })
          // 折线图
          //服务行业领域-服务时长
          data.durationByBusiScopeList.map(item => {
            this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
          })
          this.orderDurationLineArray = data.durationByBusiScopeList;
          this.options = this.orderDurationOptions;
          this.durationByBusiScopeLineArray = this.orderDurationLineArray;
          // 展示第一条
          this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
          this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
            this.durationByBusiScopeLine[0].push(item.type);
            this.durationByBusiScopeLine[1].push(item.duration);
          })
          //服务行业领域-活跃平台数
          data.snCntByBusiScopeList.map(item => {
            this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
          })
          this.activeSnLineArray = data.snCntByBusiScopeList;
          //服务行业领域-活跃用户数
          data.activeCustomerByBusiScopeList.map(item => {
            this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
          })
          this.activeCustomerLineArray = data.activeCustomerByBusiScopeList;
          //服务行业领域-新增开发者
          data.increaseCustomerByBusiScopeList.map(item => {
            this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
          })
          this.increaseCustomerLineArray = data.increaseCustomerByBusiScopeList;
          // ********************三个表格*******************************
          this.companyTableDataProps = data.companyOrderDurationTop10.map(item => {
            return Object.assign(item,{serviceTypeSelf:item.serviceType==='hawk'?'交付型':'运营型'});
          })
          this.personalTableDataProps = data.developerOrderDurationTop10;
          this.busiScopeTableProps = data.orderDurationTopByBusiScopeWithOtherInfo;
        }
      })
    },
    // getTodayDatasByCustomer() {
    //   this.resetData();
    //   this.getRequest("/dev/system/dvw/taskOrder/getTodayDatasByCustomer").then(res => {
    //     // console.log(res)
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       this.company.todayActiveCompanyCustomerCnt = data.todayActiveCompanyCustomerCnt||0;
    //       this.company.todayCompanyOrderDuration = data.todayCompanyOrderDuration||0;
    //       this.personal.todayPersonalOrderDuration = data.todayPersonalOrderDuration||0;
    //       this.personal.todayActivePersonalCustomerCnt = data.todayActivePersonalCustomerCnt || 0;
    //       this.busiScope.todayActiveBusiScopeCnt = data.todayActiveBusiScopeCnt || 0;
    //       // 服务行业领域总时长
    //       this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
    //       // 客户活跃数量
    //       this.pieOne = [
    //         { value: data.todayActiveCompanyCustomerCnt, name: '活跃客户数' },
    //         { value: data.todayIncreaseCompanyCustomerCnt, name: '新增客户数' }
    //       ]
    //       // 客户类型
    //       data.todayCompanyCustomerServiceCnt.map(item => {
    //         if(item.type==='PxyDevCloud') {
    //           this.pieTwo.push({value:item.cnt,name: '运营型'})
    //         } else {
    //           this.pieTwo.push({value:item.cnt,name: '交付型'})
    //         }
    //       })
    //       // 客户行业类型
    //       this.pieThree = data.todayCompanyCustomerBusiScopeCnt.map(item => {
    //         return {
    //           value: item.cnt,
    //           name: item.type
    //         }
    //       })
    //       // 活跃企业数
    //       data.hours24ActiveCompanyCustomerCnt.map(item => {
    //         this.companyActivityLine[0].push(item.type);
    //         this.companyActivityLine[1].push(item.cnt);
    //       })
    //       this.companyLineChart = this.companyActivityLine;
    //       // 新增企业数
    //       data.hours24IncreaseCompanyCustomerCnt.map(item => {
    //         this.increaseCompanyCustomerLine[0].push(item.type);
    //         this.increaseCompanyCustomerLine[1].push(item.cnt);
    //       })
    //       // 服务时长
    //       data.hours24CompanyOrderDuration.map(item => {
    //         this.companyOrderDurationLine[0].push(item.type);
    //         this.companyOrderDurationLine[1].push(item.duration);
    //       })
    //       // 活跃平台数
    //       data.hours24ActiveCompanySnCnt.map(item => {
    //         this.companySnLine[0].push(item.type);
    //         this.companySnLine[1].push(item.cnt);
    //       })
    //       // ********************活跃个人开发者分析*******************************
    //        // 开发者活跃数量
    //       this.pieFour = [
    //         { value: data.todayActivePersonalCustomerCnt, name: '活跃客户数' },
    //         { value: data.todayIncreasePersonalCustomerCnt, name: '新增客户数' }
    //       ]
    //       // 客户服务类型
    //       this.pieFive = data.todayPersonalCustomerBusiScopeCnt.map(item => {
    //         return {
    //           value: item.cnt,
    //           name: item.type
    //         }
    //       })
    //       // 活跃开发者数
    //       data.hours24ActivePersonalCustomerCnt.map(item => {
    //         this.activePersonalCustomerLine[0].push(item.type);
    //         this.activePersonalCustomerLine[1].push(item.cnt);
    //       })
    //       this.personalLineChart = this.activePersonalCustomerLine;
    //       // 新增开发者数
    //       data.hours24IncreasePersonalCustomerCnt.map(item => {
    //         this.increasePersonalCustomerLine[0].push(item.type);
    //         this.increasePersonalCustomerLine[1].push(item.cnt);
    //       })
    //       // 服务时长
    //       data.hours24PersonalOrderDuration.map(item => {
    //         this.personalOrderDurationLine[0].push(item.type);
    //         this.personalOrderDurationLine[1].push(item.duration);
    //       })
    //       // ********************服务行业领域分析*******************************
    //       // 服务时长
    //       data.dayOrderDurationTopByBusiScope.map(item => {
    //         this.orderDurationTopByBusiScopeBar[0].push(item.type);
    //         this.orderDurationTopByBusiScopeBar[1].push(item.duration);
    //       })
    //       this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
    //       // 活跃平台数
    //       data.dayActiveSnTopByBusiScope.map(item => {
    //         this.activeSnTopByBusiScopeBar[0].push(item.type);
    //         this.activeSnTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       //活跃用户数
    //       data.dayActiveCustomerTopByBusiScope.map(item => {
    //         this.activeCustomerTopByBusiScopeBar[0].push(item.type);
    //         this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       // 新增开发者
    //        data.dayIncreaseCustomerTopByBusiScope.map(item => {
    //         this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
    //         this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       // 折线图
    //       //服务行业领域-服务时长
    //       data.hours24DurationByBusiScope.map(item => {
    //         this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.orderDurationLineArray = data.hours24DurationByBusiScope;
    //       this.options = this.orderDurationOptions;
    //       this.durationByBusiScopeLineArray = this.orderDurationLineArray;
    //       // 展示第一条
    //       this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    //       this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
    //         this.durationByBusiScopeLine[0].push(item.type);
    //         this.durationByBusiScopeLine[1].push(item.duration);
    //       })
    //       //服务行业领域-活跃平台数
    //       data.hours24SnCntByBusiScope.map(item => {
    //         this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeSnLineArray = data.hours24SnCntByBusiScope;
    //       //服务行业领域-活跃用户数
    //       data.hours24ActiveCustomerByBusiScope.map(item => {
    //         this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeCustomerLineArray = data.hours24ActiveCustomerByBusiScope;
    //       //服务行业领域-新增开发者
    //       data.hours24IncreaseCustomerByBusiScope.map(item => {
    //         this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.increaseCustomerLineArray = data.hours24IncreaseCustomerByBusiScope;
    //     }
    //   })
    // },
    // getTodayTopDatasByCustomer() {
    //   this.resetData();
    //   this.getRequest('/dev/system/dvw/taskOrder/getTodayTopDatasByCustomer').then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       console.log(res.data)
    //       let data = res.data.result;
    //       this.companyTableDataProps = data.todayCompanyOrderDurationTop10.map(item => {
    //         return Object.assign(item,{serviceTypeSelf:item.serviceType==='PxyDevCloud'?'运营型':'交付型'});
    //       })
    //       this.personalTableDataProps = data.todayPersonalOrderDurationTop10;
    //       this.busiScopeTableProps = data.todayOrderDurationTopByBusiScopeWithOtherInfo;
    //     }
    //   })
    // },
    // getHistoryDatasByCustomer() {
    //   let params = {
    //     type: this.dateValue
    //   }
    //   this.resetData();
    //    this.getRequest("/dev/system/dvw/taskOrder/getHistoryDatasByCustomer",params).then(res => {
    //     // console.log(res)
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //        if(this.dateValue==='week') {
    //         this.company.todayActiveCompanyCustomerCnt = data.weekActiveCompanyCustomerCnt||0;
    //         this.company.todayCompanyOrderDuration = data.weekCompanyOrderDuration||0;
    //         this.personal.todayPersonalOrderDuration = data.weekPersonalOrderDuration||0;
    //         this.personal.todayActivePersonalCustomerCnt = data.weekActivePersonalCustomerCnt || 0;
    //         console.log(this.personal.todayActivePersonalCustomerCnt,'this.personal.todayActivePersonalCustomerCnt')
    //         this.busiScope.todayActiveBusiScopeCnt = data.weekActiveBusiScopeCnt || 0;
    //         // 服务行业领域总时长
    //         this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
    //         // 客户活跃数量
    //         this.pieOne = [
    //           { value: data.weekActiveCompanyCustomerCnt, name: '活跃客户数' },
    //           { value: data.weekIncreaseCompanyCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户类型
    //         data.weekCompanyCustomerServiceCnt.map(item => {
    //           if(item.type==='PxyDevCloud') {
    //             this.pieTwo.push({value:item.cnt,name: '运营型'})
    //           } else {
    //             this.pieTwo.push({value:item.cnt,name: '交付型'})
    //           }
    //         })
    //         // 客户行业类型
    //         this.pieThree = data.weekCompanyCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃企业数
    //         data.week7ActiveCompanyCustomerCnt.map(item => {
    //           this.companyActivityLine[0].push(item.type);
    //           this.companyActivityLine[1].push(item.cnt);
    //         })
    //         this.companyLineChart = this.companyActivityLine;
    //         // 新增企业数
    //         data.week7IncreaseCompanyCustomerCnt.map(item => {
    //           this.increaseCompanyCustomerLine[0].push(item.type);
    //           this.increaseCompanyCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         data.week7CompanyOrderDuration.map(item => {
    //           this.companyOrderDurationLine[0].push(item.type);
    //           this.companyOrderDurationLine[1].push(item.duration);
    //         })
    //         // 活跃平台数
    //         data.week7ActiveCompanySnCnt.map(item => {
    //           this.companySnLine[0].push(item.type);
    //           this.companySnLine[1].push(item.cnt);
    //         })
    //         // ********************活跃个人开发者分析*******************************
    //         // 开发者活跃数量
    //         this.pieFour = [
    //           { value: data.weekActivePersonalCustomerCnt, name: '活跃客户数' },
    //           { value: data.weekIncreasePersonalCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户服务类型
    //         this.pieFive = data.weekPersonalCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃开发者数
    //         data.week7ActivePersonalCustomerCnt.map(item => {
    //           this.activePersonalCustomerLine[0].push(item.type);
    //           this.activePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         this.personalLineChart = this.activePersonalCustomerLine;
    //         // 新增开发者数
    //         data.week7IncreasePersonalCustomerCnt.map(item => {
    //           this.increasePersonalCustomerLine[0].push(item.type);
    //           this.increasePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         data.week7PersonalOrderDuration.map(item => {
    //           this.personalOrderDurationLine[0].push(item.type);
    //           this.personalOrderDurationLine[1].push(item.duration);
    //         })
    //         // ********************服务行业领域分析*******************************
    //         // 服务时长
    //         data.weekOrderDurationTopByBusiScope.map(item => {
    //           this.orderDurationTopByBusiScopeBar[0].push(item.type);
    //           this.orderDurationTopByBusiScopeBar[1].push(item.duration);
    //         })
    //         this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
    //         // 活跃平台数
    //         data.weekActiveSnTopByBusiScope.map(item => {
    //           this.activeSnTopByBusiScopeBar[0].push(item.type);
    //           this.activeSnTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 活跃用户数
    //         data.weekActiveCustomerTopByBusiScope.map(item => {
    //           this.activeCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 新增开发者
    //         data.weekIncreaseCustomerTopByBusiScope.map(item => {
    //           this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 折线图
    //         //服务行业领域-服务时长
    //       data.week7DurationByBusiScope.map(item => {
    //         this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.orderDurationLineArray = data.week7DurationByBusiScope;
    //       this.options = this.orderDurationOptions;
    //       this.durationByBusiScopeLineArray = this.orderDurationLineArray;
    //       // 展示第一条
    //       this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    //       this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
    //         this.durationByBusiScopeLine[0].push(item.type);
    //         this.durationByBusiScopeLine[1].push(item.duration);
    //       })
    //       //服务行业领域-活跃平台数
    //       data.week7SnCntByBusiScope.map(item => {
    //         this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeSnLineArray = data.week7SnCntByBusiScope;
    //       //服务行业领域-活跃用户数
    //       data.week7ActiveCustomerByBusiScope.map(item => {
    //         this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeCustomerLineArray = data.week7ActiveCustomerByBusiScope;
    //       //服务行业领域-新增开发者
    //       data.week7IncreaseCustomerByBusiScope.map(item => {
    //         this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.increaseCustomerLineArray = data.week7IncreaseCustomerByBusiScope;
    //       }
    //       if(this.dateValue==='month') {
    //         this.company.todayActiveCompanyCustomerCnt = data.monthActiveCompanyCustomerCnt||0;
    //         this.company.todayCompanyOrderDuration = data.monthCompanyOrderDuration||0;
    //         this.personal.todayPersonalOrderDuration = data.monthPersonalOrderDuration||0;
    //         this.personal.todayActivePersonalCustomerCnt = data.monthActivePersonalCustomerCnt || 0;
    //         this.busiScope.todayActiveBusiScopeCnt = data.monthActiveBusiScopeCnt || 0;
    //         // 服务行业领域总时长
    //         this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
    //         // 客户活跃数量
    //         this.pieOne = [
    //           { value: data.monthActiveCompanyCustomerCnt, name: '活跃客户数' },
    //           { value: data.monthIncreaseCompanyCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户类型
    //         data.monthCompanyCustomerServiceCnt.map(item => {
    //           if(item.type==='PxyDevCloud') {
    //             this.pieTwo.push({value:item.cnt,name: '运营型'})
    //           } else {
    //             this.pieTwo.push({value:item.cnt,name: '交付型'})
    //           }
    //         })
    //         // 客户行业类型
    //         this.pieThree = data.monthCompanyCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃企业数
    //         data.month30ActiveCompanyCustomerCnt.map(item => {
    //           this.companyActivityLine[0].push(item.type);
    //           this.companyActivityLine[1].push(item.cnt);
    //         })
    //         this.companyLineChart = this.companyActivityLine;
    //         // 新增企业数
    //         data.month30IncreaseCompanyCustomerCnt.map(item => {
    //           this.increaseCompanyCustomerLine[0].push(item.type);
    //           this.increaseCompanyCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         data.month30CompanyOrderDuration.map(item => {
    //           this.companyOrderDurationLine[0].push(item.type);
    //           this.companyOrderDurationLine[1].push(item.duration);
    //         })
    //         // 活跃平台数
    //         data.month30ActiveCompanySnCnt.map(item => {
    //           this.companySnLine[0].push(item.type);
    //           this.companySnLine[1].push(item.cnt);
    //         })
    //         // ********************活跃个人开发者分析*******************************
    //         // 开发者活跃数量
    //         this.pieFour = [
    //           { value: data.monthActivePersonalCustomerCnt, name: '活跃客户数' },
    //           { value: data.monthIncreasePersonalCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户服务类型
    //         this.pieFive = data.monthPersonalCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃开发者数
    //         data.month30ActivePersonalCustomerCnt.map(item => {
    //           this.activePersonalCustomerLine[0].push(item.type);
    //           this.activePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         this.personalLineChart = this.activePersonalCustomerLine;
    //         // 新增开发者数
    //         data.month30IncreasePersonalCustomerCnt.map(item => {
    //           this.increasePersonalCustomerLine[0].push(item.type);
    //           this.increasePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         data.month30PersonalOrderDuration.map(item => {
    //           this.personalOrderDurationLine[0].push(item.type);
    //           this.personalOrderDurationLine[1].push(item.duration);
    //         })
    //         // ********************服务行业领域分析*******************************
    //         // 服务时长
    //         data.monthOrderDurationTopByBusiScope.map(item => {
    //           this.orderDurationTopByBusiScopeBar[0].push(item.type);
    //           this.orderDurationTopByBusiScopeBar[1].push(item.duration);
    //         })
    //         this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
    //         // 活跃平台数
    //         data.monthActiveSnCntTopByBusiScope.map(item => {
    //           this.activeSnTopByBusiScopeBar[0].push(item.type);
    //           this.activeSnTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 活跃用户数
    //         data.monthActiveCustomerTopByBusiScope.map(item => {
    //           this.activeCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 新增开发者
    //         data.monthIncreaseCustomerTopByBusiScope.map(item => {
    //           this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 折线图
    //       data.month30OrderDurationByBusiScope.map(item => {
    //         this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.orderDurationLineArray = data.month30OrderDurationByBusiScope;
    //       this.options = this.orderDurationOptions;
    //       this.durationByBusiScopeLineArray = this.orderDurationLineArray;
    //       // 展示第一条
    //       this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    //       this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
    //         this.durationByBusiScopeLine[0].push(item.type);
    //         this.durationByBusiScopeLine[1].push(item.duration);
    //       })
    //       //服务行业领域-活跃平台数
    //       data.month30SnCntByBusiScope.map(item => {
    //         this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeSnLineArray = data.month30SnCntByBusiScope;
    //       //服务行业领域-活跃用户数
    //       data.month30ActiveCustomerByBusiScope.map(item => {
    //         this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeCustomerLineArray = data.month30ActiveCustomerByBusiScope;
    //       //服务行业领域-新增开发者
    //       data.month30IncreaseCustomerByBusiScope.map(item => {
    //         this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.increaseCustomerLineArray = data.month30IncreaseCustomerByBusiScope;
    //       }
    //       if(this.dateValue==='year') {
    //         this.company.todayActiveCompanyCustomerCnt = data.yearActiveCompanyCustomerCnt||0;
    //         this.company.todayCompanyOrderDuration = data.yearCompanyOrderDuration||0;
    //         this.personal.todayPersonalOrderDuration = data.yearPersonalOrderDuration||0;
    //         this.personal.todayActivePersonalCustomerCnt = data.yearActivePersonalCustomerCnt || 0;
    //         this.busiScope.todayActiveBusiScopeCnt = data.yearActiveBusiScopeCnt || 0;
    //         // 服务行业领域总时长
    //         this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
    //         // 客户活跃数量
    //         this.pieOne = [
    //           { value: data.yearActiveCompanyCustomerCnt, name: '活跃客户数' },
    //           { value: data.yearIncreaseCompanyCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户类型
    //         data.yearCompanyCustomerServiceCnt.map(item => {
    //           if(item.type==='PxyDevCloud') {
    //             this.pieTwo.push({value:item.cnt,name: '运营型'})
    //           } else {
    //             this.pieTwo.push({value:item.cnt,name: '交付型'})
    //           }
    //         })
    //         // 客户行业类型
    //         this.pieThree = data.yearCompanyCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃企业数
    //         if(data.year12ActiveCompanyCustomerCnt) data.year12ActiveCompanyCustomerCnt.map(item => {
    //           this.companyActivityLine[0].push(item.type);
    //           this.companyActivityLine[1].push(item.cnt);
    //         })
    //         this.companyLineChart = this.companyActivityLine;
    //         // 新增企业数
    //         if(data.year12IncreaseCompanyCustomerCnt) data.year12IncreaseCompanyCustomerCnt.map(item => {
    //           this.increaseCompanyCustomerLine[0].push(item.type);
    //           this.increaseCompanyCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         if(data.year12CompanyOrderDuration) data.year12CompanyOrderDuration.map(item => {
    //           this.companyOrderDurationLine[0].push(item.type);
    //           this.companyOrderDurationLine[1].push(item.duration);
    //         })
    //         // 活跃平台数
    //         if(data.year12ActiveCompanySnCnt) data.year12ActiveCompanySnCnt.map(item => {
    //           this.companySnLine[0].push(item.type);
    //           this.companySnLine[1].push(item.cnt);
    //         })
    //         // ********************活跃个人开发者分析*******************************
    //         // 开发者活跃数量
    //         this.pieFour = [
    //           { value: data.yearActivePersonalCustomerCnt, name: '活跃客户数' },
    //           { value: data.yearIncreasePersonalCustomerCnt, name: '新增客户数' }
    //         ]
    //         // 客户服务类型
    //         this.pieFive = data.yearPersonalCustomerBusiScopeCnt.map(item => {
    //           return {
    //             value: item.cnt,
    //             name: item.type
    //           }
    //         })
    //         // 活跃开发者数
    //         if(data.year12ActivePersonalCustomerCnt) data.year12ActivePersonalCustomerCnt.map(item => {
    //           this.activePersonalCustomerLine[0].push(item.type);
    //           this.activePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         this.personalLineChart = this.activePersonalCustomerLine;
    //         // 新增开发者数
    //         if(data.year12IncreasePersonalCustomerCnt) data.year12IncreasePersonalCustomerCnt.map(item => {
    //           this.increasePersonalCustomerLine[0].push(item.type);
    //           this.increasePersonalCustomerLine[1].push(item.cnt);
    //         })
    //         // 服务时长
    //         if(data.year12PersonalOrderDuration) data.year12PersonalOrderDuration.map(item => {
    //           this.personalOrderDurationLine[0].push(item.type);
    //           this.personalOrderDurationLine[1].push(item.duration);
    //         })
    //         // ********************服务行业领域分析*******************************
    //         // 服务时长
    //         if(data.yearOrderDurationTopByBusiScope) data.yearOrderDurationTopByBusiScope.map(item => {
    //           this.orderDurationTopByBusiScopeBar[0].push(item.type);
    //           this.orderDurationTopByBusiScopeBar[1].push(item.duration);
    //         })
    //         this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
    //         // 活跃平台数
    //         if(data.yearActiveSnTopByBusiScope) data.yearActiveSnTopByBusiScope.map(item => {
    //           this.activeSnTopByBusiScopeBar[0].push(item.type);
    //           this.activeSnTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 活跃用户数
    //         if(data.yearActiveCustomerTopByBusiScope) data.yearActiveCustomerTopByBusiScope.map(item => {
    //           this.activeCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 新增开发者
    //         if(data.yearIncreaseCustomerTopByBusiScope) data.yearIncreaseCustomerTopByBusiScope.map(item => {
    //           this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
    //           this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
    //         })
    //         // 折线图
    //       data.year12DurationByBusiScope.map(item => {
    //         this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.orderDurationLineArray = data.year12DurationByBusiScope;
    //       this.options = this.orderDurationOptions;
    //       this.durationByBusiScopeLineArray = this.orderDurationLineArray;
    //       // 展示第一条
    //       this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    //       this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
    //         this.durationByBusiScopeLine[0].push(item.type);
    //         this.durationByBusiScopeLine[1].push(item.duration);
    //       })
    //       //服务行业领域-活跃平台数
    //       data.year12SnCntByBusiScope.map(item => {
    //         this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeSnLineArray = data.year12SnCntByBusiScope;
    //       //服务行业领域-活跃用户数
    //       data.year12ActiveCustomerByBusiScope.map(item => {
    //         this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeCustomerLineArray = data.year12ActiveCustomerByBusiScope;
    //       //服务行业领域-新增开发者
    //       data.year12IncreaseCustomerByBusiScope.map(item => {
    //         this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.increaseCustomerLineArray = data.year12IncreaseCustomerByBusiScope;
    //       }
    //     }
    //   })
    // },
    // getHistoryTopDatasByCustomer() {
    //   let params = {
    //     type: this.dateValue
    //   }
    //   this.resetData();
    //   this.getRequest('/dev/system/dvw/taskOrder/getHistoryTopDatasByCustomer',params).then(res => {
    //      if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       if(this.dateValue==='week') {
    //         this.companyTableDataProps = data.weekCompanyOrderDurationTop10.map(item => {
    //           return Object.assign(item,{serviceTypeSelf:item.serviceType==='PxyDevCloud'?'运营型':'交付型'});
    //         })
    //         this.personalTableDataProps = data.weekPersonalOrderDurationTop10;
    //         this.busiScopeTableProps = data.weekOrderDurationTopByBusiScopeWithOtherInfo;
    //       }
    //       if(this.dateValue==='month') {
    //         this.companyTableDataProps = data.monthCompanyOrderDurationTop10.map(item => {
    //           return Object.assign(item,{serviceTypeSelf:item.serviceType==='PxyDevCloud'?'运营型':'交付型'});
    //         })
    //         this.personalTableDataProps = data.monthPersonalOrderDurationTop10;
    //         this.busiScopeTableProps = data.monthOrderDurationTopByBusiScopeWithOtherInfo;
    //       }
    //       if(this.dateValue==='year') {
    //         this.companyTableDataProps = data.yearCompanyOrderDurationTop10.map(item => {
    //           return Object.assign(item,{serviceTypeSelf:item.serviceType==='PxyDevCloud'?'运营型':'交付型'});
    //         })
    //         this.personalTableDataProps = data.yearPersonalOrderDurationTop10;
    //         this.busiScopeTableProps = data.yearOrderDurationTopByBusiScopeWithOtherInfo;
    //       }
    //     }
    //   })
    // },
    // getDatasByCustomer() {
    //   let params = {
    //     startDate: this.dateValue[0],
    //     endDate: this.dateValue[1]
    //   }
    //   this.resetData();
    //   this.getRequest("/dev/system/dvw/taskOrder/getMonthHistoryDatasByCustomer",params).then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       this.company.todayActiveCompanyCustomerCnt = data.activeCompanyCustomerCnt[0]?data.activeCompanyCustomerCnt[0].value:0;
    //       this.company.todayCompanyOrderDuration = data.companyOrderDuration[0]?data.companyOrderDuration[0].value: 0;
    //       this.personal.todayPersonalOrderDuration = data.personalOrderDuration[0]||0?data.personalOrderDuration[0].value:0;
    //       this.personal.todayActivePersonalCustomerCnt = data.activePersonalCustomerCnt[0]? data.activePersonalCustomerCnt[0].value: 0;
    //       this.busiScope.todayActiveBusiScopeCnt = data.activeBusiScopeCnt[0]?data.activeBusiScopeCnt[0].value: 0;
    //       // 服务行业领域总时长
    //       this.busiScope.busiScopeDurationTotal = this.cal.add(this.personal.todayPersonalOrderDuration,this.company.todayCompanyOrderDuration);
    //       // 客户活跃数量
    //       console.log(data.activeCompanyCustomerCnt,'data.activeCompanyCustomerCnt')
    //       this.pieOne = [
    //         { value: data.activeCompanyCustomerCnt[0]?data.activeCompanyCustomerCnt[0].value:'', name: '活跃客户数' },
    //         { value: data.increaseCompanyCustomerCnt[0]?data.increaseCompanyCustomerCnt[0]:'', name: '新增客户数' }
    //       ]
    //       // // 客户类型
    //       let companyCustomerServiceCntVal = JSON.parse(data.companyCustomerServiceCnt[0].value).result;
    //       companyCustomerServiceCntVal.map(item => {
    //         if(item.type==='PxyDevCloud') {
    //           this.pieTwo.push({value:item.cnt,name: '运营型'})
    //         } else {
    //           this.pieTwo.push({value:item.cnt,name: '交付型'})
    //         }
    //       })
    //       // // 客户行业类型
    //       let companyCustomerBusiScopeCntVal = JSON.parse(data.companyCustomerBusiScopeCnt[0].value).result;
    //       this.pieThree = companyCustomerBusiScopeCntVal.map(item => {
    //         return {
    //           value: item.cnt,
    //           name: item.type
    //         }
    //       })
    //       // // 活跃企业数
    //       let month30ActiveCompanyCustomerCntVal = JSON.parse(data.month30ActiveCompanyCustomerCnt[0].value).result;
    //       month30ActiveCompanyCustomerCntVal.map(item => {
    //         this.companyActivityLine[0].push(item.type);
    //         this.companyActivityLine[1].push(item.cnt);
    //       })
    //       this.companyLineChart = this.companyActivityLine;
    //       // // 新增企业数
    //       let month30IncreaseCompanyCustomerCntVal = JSON.parse(data.month30IncreaseCompanyCustomerCnt[0].value).result;
    //       month30IncreaseCompanyCustomerCntVal.map(item => {
    //         this.increaseCompanyCustomerLine[0].push(item.type);
    //         this.increaseCompanyCustomerLine[1].push(item.cnt);
    //       })
    //       // // 服务时长
    //       let month30CompanyOrderDurationVal = JSON.parse(data.month30CompanyOrderDuration[0].value).result;
    //       month30CompanyOrderDurationVal.map(item => {
    //         this.companyOrderDurationLine[0].push(item.type);
    //         this.companyOrderDurationLine[1].push(item.duration);
    //       })
    //       // // 活跃平台数
    //       let month30ActiveCompanySnCntVal = JSON.parse(data.month30ActiveCompanySnCnt[0].value).result;
    //       month30ActiveCompanySnCntVal.map(item => {
    //         this.companySnLine[0].push(item.type);
    //         this.companySnLine[1].push(item.cnt);
    //       })
    //       let companyOrderDurationTop10Val = JSON.parse(data.companyOrderDurationTop10[0].value).result;
    //       this.companyTableDataProps = companyOrderDurationTop10Val.map(item => {
    //         return Object.assign(item,{serviceTypeSelf:item.serviceType==='PxyDevCloud'?'运营型':'交付型'});
    //       })
    //       // // ********************活跃个人开发者分析*******************************
    //       //  // 开发者活跃数量
    //       this.pieFour = [
    //         { value: data.activePersonalCustomerCnt[0].value, name: '活跃客户数' },
    //         { value: data.increasePersonalCustomerCnt[0].value, name: '新增客户数' }
    //       ]
    //       // // 客户服务类型
    //       let personalCustomerBusiScopeCntVal = JSON.parse(data.personalCustomerBusiScopeCnt[0].value).result;
    //       this.pieFive = personalCustomerBusiScopeCntVal.map(item => {
    //         return {
    //           value: item.cnt,
    //           name: item.type
    //         }
    //       })
    //       // // 活跃开发者数
    //       let month30ActivePersonalCustomerCntVal = JSON.parse(data.month30ActivePersonalCustomerCnt[0].value).result;
    //       month30ActivePersonalCustomerCntVal.map(item => {
    //         this.activePersonalCustomerLine[0].push(item.type);
    //         this.activePersonalCustomerLine[1].push(item.cnt);
    //       })
    //       this.personalLineChart = this.activePersonalCustomerLine;
    //       // // 新增开发者数
    //       let month30IncreasePersonalCustomerCntVal = JSON.parse(data.month30IncreasePersonalCustomerCnt[0].value).result;
    //       month30IncreasePersonalCustomerCntVal.map(item => {
    //         this.increasePersonalCustomerLine[0].push(item.type);
    //         this.increasePersonalCustomerLine[1].push(item.cnt);
    //       })
    //       // // 服务时长
    //       let month30PersonalOrderDurationVal = JSON.parse(data.month30PersonalOrderDuration[0].value).result;
    //       month30PersonalOrderDurationVal.map(item => {
    //         this.personalOrderDurationLine[0].push(item.type);
    //         this.personalOrderDurationLine[1].push(item.duration);
    //       })
    //       let personalOrderDurationTop10Val = JSON.parse(data.personalOrderDurationTop10[0].value).result;
    //       console.log(personalOrderDurationTop10Val,'personalOrderDurationTop10Val')
    //       this.personalTableDataProps = personalOrderDurationTop10Val;
    //       // // ********************服务行业领域分析*******************************
    //       // 服务时长
    //       let month30OrderDurationByBusiScopeVal = JSON.parse(data.orderDurationTopByBusiScopeWithOtherInfo[0].value).result;
    //       month30OrderDurationByBusiScopeVal.map(item => {
    //         this.orderDurationTopByBusiScopeBar[0].push(item.busiScope);
    //         this.orderDurationTopByBusiScopeBar[1].push(item.duration);
    //       })
    //       this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
    //       // 活跃平台数
    //       let activeSnCntTopByBusiScopeVal = JSON.parse(data.activeSnCntTopByBusiScope[0].value).result;
    //       activeSnCntTopByBusiScopeVal.map(item => {
    //         this.activeSnTopByBusiScopeBar[0].push(item.type);
    //         this.activeSnTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       // // 活跃用户数
    //       let activeCustomerTopByBusiScopeVal = JSON.parse(data.activeCustomerTopByBusiScope[0].value).result;
    //       activeCustomerTopByBusiScopeVal.map(item => {
    //         this.activeCustomerTopByBusiScopeBar[0].push(item.type);
    //         this.activeCustomerTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       // // 新增开发者
    //       let month30IncreaseCustomerByBusiScopeVal = JSON.parse(data.increaseCustomerTopByBusiScope[0].value).result;
    //        month30IncreaseCustomerByBusiScopeVal.map(item => {
    //         this.increaseCustomerTopByBusiScopeBar[0].push(item.type);
    //         this.increaseCustomerTopByBusiScopeBar[1].push(item.cnt);
    //       })
    //       // // 折线图
    //       let orderDurationTopByBusiScopeWithOtherInfoVal = JSON.parse(data.month30OrderDurationByBusiScope[0].value).result;
    //       orderDurationTopByBusiScopeWithOtherInfoVal.map(item => {
    //         this.orderDurationOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.orderDurationLineArray = orderDurationTopByBusiScopeWithOtherInfoVal;
    //       this.options = this.orderDurationOptions;
    //       this.durationByBusiScopeLineArray = this.orderDurationLineArray;
    //       // 展示第一条
    //       this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    //       console.log(this.durationByBusiScopeLineArray,'this.busiScopeLineSelectvalue')
    //       this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
    //         this.durationByBusiScopeLine[0].push(item.type);
    //         this.durationByBusiScopeLine[1].push(item.duration);
    //       })
    //       //服务行业领域-活跃平台数
    //       let activeSnCntTopByBusiScopeLineVal = JSON.parse(data.month30SnCntByBusiScope[0].value).result;
    //       activeSnCntTopByBusiScopeLineVal.map(item => {
    //         this.activeSnOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeSnLineArray = activeSnCntTopByBusiScopeLineVal;
    //       //服务行业领域-活跃用户数
    //       let activeCustomerTopByBusiScopeLineVal = JSON.parse(data.month30ActiveCustomerByBusiScope[0].value).result;
    //       activeCustomerTopByBusiScopeLineVal.map(item => {
    //         this.activeCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.activeCustomerLineArray = activeCustomerTopByBusiScopeLineVal;
    //       //服务行业领域-新增开发者
    //       let increaseCustomerTopByBusiScopeVal = JSON.parse(data.month30IncreaseCustomerByBusiScope[0].value).result;
    //       increaseCustomerTopByBusiScopeVal.map(item => {
    //         this.increaseCustomerOptions.push({value: item.busiScope,label: item.busiScope});
    //       })
    //       this.increaseCustomerLineArray = increaseCustomerTopByBusiScopeVal;
    //       // console.log(orderDurationTopByBusiScopeWithOtherInfoVal)
    //       // if(orderDurationTopByBusiScopeWithOtherInfoVal[0]) {
    //       //    this.busiScopeLineSelectvalue = orderDurationTopByBusiScopeWithOtherInfoVal[0].busiScope;
    //       //    if(orderDurationTopByBusiScopeWithOtherInfoVal[0].cntAndDurationList){
    //       //      orderDurationTopByBusiScopeWithOtherInfoVal[0].cntAndDurationList.map(item => {
    //       //       this.durationByBusiScopeLine[0].push(item.busiScope);
    //       //       this.durationByBusiScopeLine[1].push(item.duration);
    //       //     })
    //       //    }
             
    //       // }
    //       // this.durationByBusiScopeLineArray = orderDurationTopByBusiScopeWithOtherInfoVal;
    //       // orderDurationTopByBusiScopeWithOtherInfoVal.map(item => {
    //       //   // 下拉options
    //       //   this.options.push({value: item.busiScope,label: item.busiScope});
    //       // })
    //       let busiScopeTable = JSON.parse(data.orderDurationTopByBusiScopeWithOtherInfo[0].value).result;
    //       this.busiScopeTableProps = busiScopeTable;

    //     }
    //   })
    // },

    selectBusiScopeChange(value) {
      let arr = this.durationByBusiScopeLineArray.find(item => item.busiScope==value);
      this.durationByBusiScopeLine = [[],[]];
      if(arr.cntAndDurationList) {
        arr.cntAndDurationList.map(item => {
          this.durationByBusiScopeLine[0].push(item.type);
          if(this.busiScopeTab==='服务时长') {
            this.durationByBusiScopeLine[1].push(item.duration);
          }else {
            this.durationByBusiScopeLine[1].push(item.cnt);
          }
        })
      }
    },
    // 个人开发者分析折线图点击切换
    personalTabClick(value) {
      this.personalTab = value;
      switch (value){
        case '活跃开发者':
          this.personalLineChart = this.activePersonalCustomerLine;
          break;
        case '新增开发者':
          this.personalLineChart = this.increasePersonalCustomerLine;
          break;
        case '服务时长':
          this.personalLineChart = this.personalOrderDurationLine;
          break;
      }
    },
    // 企业开发者分析折线图点击切换
    companyTabClick(value) {
      this.companyTab = value;
      switch (value){
        case '活跃企业':
          this.companyLineChart = this.companyActivityLine;
          break;
        case '新增企业':
          this.companyLineChart = this.increaseCompanyCustomerLine;
          break;
        case '服务时长':
          // this.companyLineChart = this.hours24CompanyOrderDuration;
          this.companyLineChart = this.companyOrderDurationLine;
          break;
        case '活跃平台':
          this.companyLineChart = this.companySnLine;
          break;
      }
    },

    // 服务行业分析柱状图点击切换
    busiScopeTabClick(value) {
      this.busiScopeTab = value;
      this.busiScopeLineSelectvalue = '',
      this.options = [];
      this.durationByBusiScopeLineArray = [];
      this.durationByBusiScopeLine = [[],[]];
      switch (value){
        case '服务时长':
          this.orderDurationTopByBusiScopeChart = this.orderDurationTopByBusiScopeBar;
          this.options = this.orderDurationOptions;
          this.durationByBusiScopeLineArray = this.orderDurationLineArray;
          this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
            this.durationByBusiScopeLine[0].push(item.type);
            this.durationByBusiScopeLine[1].push(item.duration);
          })
          break;
        case '活跃平台':
          this.orderDurationTopByBusiScopeChart = this.activeSnTopByBusiScopeBar;
          this.options = this.activeSnOptions;
          this.durationByBusiScopeLineArray = this.activeSnLineArray;
          this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
            this.durationByBusiScopeLine[0].push(item.type);
            this.durationByBusiScopeLine[1].push(item.cnt);
          })
          break;
        case '活跃用户':
          this.orderDurationTopByBusiScopeChart = this.activeCustomerTopByBusiScopeBar;
          this.options = this.activeCustomerOptions;
          this.durationByBusiScopeLineArray = this.activeCustomerLineArray;
          this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
            this.durationByBusiScopeLine[0].push(item.type);
            this.durationByBusiScopeLine[1].push(item.cnt);
          })
          break;
        case '新增开发者':
          this.orderDurationTopByBusiScopeChart = this.increaseCustomerTopByBusiScopeBar;
          this.options = this.increaseCustomerOptions;
          this.durationByBusiScopeLineArray = this.increaseCustomerLineArray;
          this.durationByBusiScopeLineArray[0].cntAndDurationList.map(item => {
            this.durationByBusiScopeLine[0].push(item.type);
            this.durationByBusiScopeLine[1].push(item.cnt);
          })
          break;
      }
      this.busiScopeLineSelectvalue = this.durationByBusiScopeLineArray[0].busiScope;
    },
    resetData() {
      this.company = {
        todayActiveCompanyCustomerCnt: 0, // 活跃客户
        todayCompanyOrderDuration: 0, //服务时长
      };
      this.personal = {
        todayActivePersonalCustomerCnt: 0, // 活跃开发者
        todayPersonalOrderDuration: 0, //服务时长
      };
      this.busiScope = {
        todayActiveBusiScopeCnt: 0, // 服务行业数
        busiScopeDurationTotal: 0, // 服务时长
      };
      this.pieOne = [];
      this.pieTwo = [];
      this.pieThree = [];
      this.companyLineChart = [];
      // 活跃企业折线图
      this.companyActivityLine = [[],[]];
      this.increaseCompanyCustomerLine = [[],[]]; // 新增企业数
      this.companyOrderDurationLine = [[],[]]; //服务时长
      this.companySnLine = [[],[]]; // 活跃平台数
      this.companyTableDataProps = []; //企业开发者排行
      this.personalTableDataProps = []; //个人开发者排行
      this.busiScopeTableProps = []; //服务行业排行
      this.pieFour = []; // 开发者活跃数量
      this.pieFive = []; // 客户服务类型
      this.personalLineChart = [];
      this.activePersonalCustomerLine = [[],[]]; //活跃开发者数
      this.increasePersonalCustomerLine = [[],[]]; // 新增开发者数
      this.personalOrderDurationLine = [[],[]]; // 服务时长
      this.orderDurationTopByBusiScopeChart = [];
      this.orderDurationTopByBusiScopeBar = [[],[]]; //服务行业领域-服务时长
      this.activeSnTopByBusiScopeBar = [[],[]]; //服务行业领域-活跃平台数
      this.activeCustomerTopByBusiScopeBar = [[],[]]; //服务行业领域-活跃企业数
      this.increaseCustomerTopByBusiScopeBar = [[],[]]; //服务行业领域-新增开发者
      this.busiScopeTab = '服务时长';
      this.companyTab = '活跃企业';
      this.personalTab = '活跃开发者';
      // 服务行业折线图下拉勾选
      this.busiScopeLineSelectvalue = '',
      this.options = [];
      this.durationByBusiScopeLineArray = [];
      this.durationByBusiScopeLine = [[],[]];
      this.orderDurationOptions =  []; //服务行业领域-服务时长
      this.activeSnOptions =  []; //服务行业领域-活跃平台数
      this.activeCustomerOptions =  []; //服务行业领域-活跃用户数
      this.increaseCustomerOptions =  []; //服务行业领域-新增开发者
      this.orderDurationLineArray =  []; //服务行业领域-服务时长
      this.activeSnLineArray =  []; //服务行业领域-活跃平台数
      this.activeCustomerLineArray =  []; //服务行业领域-活跃用户数
      this.increaseCustomerLineArray =  []; //服务行业领域-新增开发者
    }
  }
}
</script>
<style lang='scss' scoped>
 .developer {
   .choose-date {
      height: 39px;
      margin-top: 30px;
      margin-bottom: 50px;
      border-bottom: 1px solid #333;
      padding-bottom: 10px;
   }
  //  图表标题总结
  .summary-row {
    box-sizing: border-box;
    >div:nth-of-type(1) {
      padding-right: 50px;
      box-sizing: border-box;
    }
    >div:nth-of-type(2) {
      padding-left: 50px;
      box-sizing: border-box;
    }
  }
   .chart-summary {
      box-sizing: border-box;
     >div:nth-of-type(1) {
       box-sizing: border-box;
       margin-bottom: 50px;
       >div:nth-of-type(1) {
         height: 100%;
        background: #F28639;
        border-radius: 10px;
        padding: 10px 15px;
        box-sizing: border-box;
        font-size: 20px;
        color:#fff;
        vertical-align: bottom;
       }
       >div:nth-of-type(2),
       >div:nth-of-type(3) {
         font-size: 14px;
         >i {
           display: inlie-block;
           font-size: 36px;
           border-bottom: 1px solid #000;
           font-weight: 600;
           padding: 5px 10px 0 10px;
         }
       }
     }
     >div:nth-of-type(2) {
       box-sizing: border-box;
     }
   }
   .line-tab {
     padding-left: 20px;
     box-sizing: border-box;
     margin-top: 80px;
     span {
       display: inline-block;
       margin-right: 50px;
       padding-bottom: 10px;
       box-sizing: border-box;
       font-size: 16px;
       font-weight: 600;
       cursor: pointer;
       color: #5E5E5E;
     }
     .active {
       color: #F28639;
       border-bottom: 3px solid #F28639;
     }
     .personal-active {
       color: #A89700;
       border-bottom: 3px solid #A89700;
     }
   }
   .serve-tab {
     padding-left: 20px;
     box-sizing: border-box;
     margin-bottom:20px;
     span {
       display: inline-block;
       margin-right: 50px;
       padding-bottom: 10px;
       box-sizing: border-box;
       font-size: 16px;
       font-weight: 600;
       cursor: pointer;
       color: #5E5E5E;
     }
     .active {
       color: #5B9BD5;
       border-bottom: 3px solid #5B9BD5;
     }
   }
 }
 </style>
